import { Close } from '@mui/icons-material';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import { ComponentProps } from 'react';

import { PresenceDialog } from '@/tracker/ui/PresenceDialog';

import { WorklogForm } from '../WorklogForm';

import s from './WorklogFormDialog.module.scss';

type Props = ComponentProps<typeof WorklogForm> & {
  open: boolean;
  title: string;
};

/** Форма записи времени в диалоге: новая запись и правка существующей */
const WorklogFormDialog: React.FC<Props> = ({ open, title, ...formProps }) => (
  <PresenceDialog
    open={open}
    onClose={formProps.onCancel}
    fullWidth
    // Начало, затрачено и остаток помещаются в одну строку
    slotProps={{ paper: { sx: { maxWidth: 680 } } }}
  >
    <DialogTitle className={s.title}>
      {title}
      <IconButton aria-label="Закрыть" onClick={formProps.onCancel}>
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <WorklogForm {...formProps} />
    </DialogContent>
  </PresenceDialog>
);

export { WorklogFormDialog };
